import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { apiConfig } from "../../../utils/apiConfig";
import SubPageLayout from "../../../components/shared/SubPageLayout";
import { useAuth } from "../../../contexts/AuthContext";

import logger from '../../../utils/logger';

const TaxPlanning = () => {
  const { householdId } = useParams();
  const [household, setHousehold] = useState(null);
  const [loading, setLoading] = useState(true);
  const { token } = useAuth();

  useEffect(() => {
    const fetchHouseholdData = async () => {
      try {
        if (!token) {
          logger.info("No token found");
          return;
        }

        const response = await apiConfig.api.get(
          `/advisor-portal/client-database/household-profile/${householdId}/tax-planning`,
        );

        if (response.data) {
          setHousehold(response.data);
        }
      } catch (err) {
        logger.error("Error fetching household data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchHouseholdData();
  }, [householdId, token]);

  return (
    <SubPageLayout
      title="Tax Planning"
      subtitle="View household tax planning"
      breadcrumbItems={[
        { label: "Advisor Portal", path: "/advisor-portal" },
        { label: "Client Database", path: "/advisor-portal/client-database" },
        {
          label: "Household Profile",
          path: `/advisor-portal/client-database/household-profile/${householdId}`,
        },
        {
          label: "Tax Planning",
          path: `/advisor-portal/client-database/household-profile/${householdId}/tax-planning`,
        },
      ]}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {loading ? (
          <div className="col-span-full text-center py-4">Loading...</div>
        ) : household ? (
          <>
            <div className="col-span-full">
              <h2 className="text-2xl font-bold mb-4">Tax Information</h2>
              {/* Add tax planning content here */}
            </div>
          </>
        ) : (
          <div className="col-span-full text-center py-4">
            No tax planning data found
          </div>
        )}
      </div>
    </SubPageLayout>
  );
};

export default TaxPlanning;
